import { Grid, TextField } from '@mui/material'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'

/**
 *
 * @param {Object} props
 * @param {JSX.Element} props.AlertElement
 * @param {Function} props.setAlertElement
 * @param {string} props.workflowCopyName
 * @param {string} props.workflowCopyDescription
 * @param {Function} props.setWorkflowCopyName
 * @param {Function} props.setWorkflowCopyDescription
 * @returns {JSX.Element}
 */
const WorkflowCopyDialog = ({ AlertElement, workflowCopyName, workflowCopyDescription, setWorkflowCopyName, setWorkflowCopyDescription }) => {
  const { t_ } = useSmartTranslation()

  return (
    <>
      {AlertElement}
      <Grid container spacing={3} sx={{ padding: (theme) => theme.spacing(2) }}>
        <Grid item xs={4}>
          <TextField
            value={workflowCopyName}
            label={t_('Name')} onChange={(event) => { setWorkflowCopyName(event.target.value) }}
            inputProps={{
              maxLength: 45
            }}
          />
        </Grid>
        <Grid item xs={8}>
          <TextField
            sx={{ width: '100%' }}
            value={workflowCopyDescription}
            label={t_('Description')} onChange={(event) => { setWorkflowCopyDescription(event.target.value) }}
            inputProps={{
              maxLength: 250
            }}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default WorkflowCopyDialog
